import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { optimiseImage } from 'src/common/utils/prismic-image';

class Video extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    autoPlay: PropTypes.bool,
    preload: PropTypes.string,
    playsInline: PropTypes.bool,
    muted: PropTypes.bool,
    isOnScreen: PropTypes.bool,
    replayOnEnd: PropTypes.bool,
    poster: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    loop: PropTypes.bool
  };

  static defaultProps = {
    replayOnEnd: false,
    preload: 'none',
    autoPlay: false,
    playsInline: true,
    muted: true
  };

  constructor(props) {
    super(props);
    this._$video = null;
    this.play = this.play.bind(this);
    this.onVideoRef = this.onVideoRef.bind(this);
  }

  componentDidMount() {
    if (this.props.isOnScreen) {
      this.play();
    }
  }

  componentWillUnmount() {
    this._$video = null;
  }

  componentDidUpdate(prev) {
    if (!prev.isOnScreen && this.props.isOnScreen) {
      this.play();
    }
  }

  play() {
    if (this._$video) {
      try {
        this._$video.play();
      } catch (error) {
        // silence errors if not supported
      }
    }
  }

  onVideoRef($el) {
    this._$video = $el;
  }

  render() {
    return (
      <video
        style={{
          width: '100%',
          objectFit: 'cover',
        }}
        ref={this.onVideoRef}
        src={this.props.src}
        poster={optimiseImage(this.props.poster)}
        autoPlay={this.props.autoPlay}
        preload={this.props.preload}
        playsInline={this.props.playsInline}
        muted={this.props.muted}
        loop={this.props.replayOnEnd}
        className={this.props.className}>
        {this.props.children}
      </video>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Video/Video.js